import { render, staticRenderFns } from "./Customer-CSKH.vue?vue&type=template&id=0f03dd31&scoped=true"
import script from "./Customer-CSKH.vue?vue&type=script&lang=js"
export * from "./Customer-CSKH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f03dd31",
  null
  
)

export default component.exports